import { BreakpointsOptions } from '@mui/material';

const breakpoints: BreakpointsOptions = {
  values: {
    xs: 0, // mobile
    sm: 768, // tablet
    md: 1280, // laptop
    lg: 1440, // desktop
    xl: 1920,
  },
};

export default breakpoints;
